import type { BrandContext, BrandKitInput, BrandKitView, LookView } from '@alterium/shared';
import { api } from './client';

export const looksApi = {
  list: () => api.get<LookView[]>('/looks'),
  get: (id: string) => api.get<LookView>(`/looks/${id}`),
  create: (input: {
    name: string;
    prompt?: string;
    referenceAssetIds?: string[];
    /** Место без людей: уходит фоном сцены, а не «образом». */
    isLocation?: boolean;
    /** Формат кадра: фон обязан совпадать с форматом ролика. */
    aspectRatio?: string;
    count?: number;
  }) => api.post<LookView>('/looks', input),
  variants: (id: string, params: { prompt?: string; count?: number }) =>
    api.post<LookView>(`/looks/${id}/variants`, params),
  update: (id: string, patch: { name?: string; selectedVariantId?: string; isPrimary?: boolean }) =>
    api.patch<LookView>(`/looks/${id}`, patch),
  remove: (id: string) => api.delete(`/looks/${id}`),
};

export const brandApi = {
  get: () => api.get<BrandKitView>('/brand-kit'),
  update: (patch: Partial<BrandKitInput>) => api.patch<BrandKitView>('/brand-kit', patch),
  context: (aspectRatio = '9:16') =>
    api.get<BrandContext>(`/brand-kit/context?aspectRatio=${encodeURIComponent(aspectRatio)}`),
};
